import * as yup from "yup";

export const userDetails = yup.object({
  firstName: yup
    .string()
    .required("First Name is required")
    .matches(/^[A-Za-z\s]+$/, "First Name should not contain numbers"),
  lastName: yup
    .string()
    .required("Last Name is required")
    .matches(/^[A-Za-z\s]+$/, "Last Name should not contain numbers"),
  email: yup.string().required("Email is required").email("Email is not valid"),
});
